import React from 'react';
import useFeatureToggleService from 'feature-toggle';
import BaseTasksPage from '../BaseTasksPage';
import useAdditionalWorkflowLaunchNavigator from './additionalWorkflowLaunchNavigator';
import AdditionalWorkflowSteps, { AdditionalWorkflowStepId } from './AdditionalWorkflowSteps';
import { useConflictsContext } from './AdditionalWorkflowLaunchWrapper';
import { useProjectContext } from '../../view/ProjectContext';

export default function AdditionalWorkflowAllTasksPage() {
  const navigator = useAdditionalWorkflowLaunchNavigator();
  const conflictsContext = useConflictsContext();
  const featureToggleService = useFeatureToggleService();
  const isNewFlowEnabled = featureToggleService.isApplyAdditionalWorkflowEnabled();
  const projectContext = useProjectContext();

  const handleNext = (isNewFlowEnabled && conflictsContext.hasConflicts)
    ? navigator.openConflictsPage
    : navigator.openPartiesPage;

  return (
    <BaseTasksPage
      roadmap={(
        <AdditionalWorkflowSteps
          currentStep={AdditionalWorkflowStepId.ALL_TASKS}
          hasConflicts={conflictsContext.hasConflicts}
          hasGroups={projectContext.plan?.hasGroups}
        />
      )}
      onPrevClicked={navigator.openKeyDateTasksPage}
      onNextClicked={handleNext}
    />
  );
}
